/* import __COLOCATED_TEMPLATE__ from './group-details-modal.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import templateOnlyComponent from '@ember/component/template-only';
import type { ScimGroup, ScimUser, Role, DropdownGroup } from './types';

interface Args {
  isVisible: boolean;
  selectedGroup: ScimGroup | null;
  groupChanges: Record<string, { role_id: number | null }>;
  availableRoles: Role[];
  isLoadingGroupDetails: boolean;
  hasCurrentGroupChanges: boolean;
  isLoading: boolean;
  onClose: () => void;
  onApplyCurrentGroupChanges: () => void;
  getGroupPriority: (group: ScimGroup) => number;
  getUserInitials: (user: ScimUser) => string;
  modalRoleDropdownList: DropdownGroup[];
  currentModalRoleName: string;
}

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
  Blocks: {};
}

const ScimGroupDetailsModal = templateOnlyComponent<Signature>();
export default ScimGroupDetailsModal;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Teammates::Scim::GroupDetailsModal': typeof ScimGroupDetailsModal;
    'new-settings/workspace/teammates/scim/group-details-modal': typeof ScimGroupDetailsModal;
  }
}
